"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcceptInviteComponent = void 0;
const tslib_1 = require("tslib");
const mithril_component_1 = require("../../components/mithril.component");
const spinner_1 = require("../../components/spinner/spinner");
const submit_button_1 = require("../../components/submit.button");
const theme_1 = require("../../components/theme");
const index_1 = require("../../i18n/index");
const mithril_1 = require("../../mithril");
const page_1 = require("../../page/page");
const services_1 = require("../../services");
const auth_component_style_1 = require("../auth/auth.component.style");
const signup_1 = require("../signup/signup");
const signup_ctrl_1 = require("../signup/signup.ctrl");
const accept_invite_ctrl_1 = require("./accept.invite.ctrl");
const CSS = {
    container: 'c-AcceptInvite',
    footer: 'c-AcceptInvite__footer',
    textSeparator: 'c-AcceptInvite_TexSeparator'
};
(0, theme_1.addStyles)({
    [CSS.container]: {
        display: 'flex',
        'flex-direction': 'column',
        '& > .mdl-button': {
            width: '300px',
            padding: '0'
        },
        'box-sizing': 'border-box',
        'max-width': '100%',
        width: '330px', // This is needed so IE will wrap text
        'align-items': 'center;'
    },
    [CSS.textSeparator]: {
        margin: theme_1.DefaultTheme.space(4),
        color: theme_1.DefaultTheme.font.color.supporting,
        'align-self': 'stretch',
        'text-align': 'center'
    },
    [CSS.footer]: {
        padding: '20px 0',
        'text-align': 'right',
        width: '100%',
        '& a': {
            cursor: 'pointer',
            'text-decoration': 'none',
            color: theme_1.DefaultTheme.color.accent,
            'font-weight': 500
        }
    }
});
class AcceptInviteComponent extends mithril_component_1.IMithrilStateComponent {
    constructor(ctrl) {
        super();
        this.ctrl = ctrl;
        this.loggedInComponent = new LoggedInComponent(this.ctrl);
        this.chooseComponent = new InviteChooseMethodComponent(this.ctrl);
        const signupCtrl = new signup_ctrl_1.SignupCtrl(success => this.acceptNewSSOUser(!!success));
        this.successSSOComponent = new InviteSuccessSSOComponent(this.ctrl);
        this.failedSSOComponent = new InviteFailedSSOComponent(this.ctrl);
        this.invalidAccountComponent = new InviteInvalidAccountComponent(this.ctrl);
        if (services_1.Services.SSO.isAuthenticated) {
            this.checkValidEmail();
        }
        /**
         * We don't need a login CTRL or component here as after the user is redirected to Auth0 for login
         *  they come back with no page state so they will follow the same flow as if they were already authenticated
         * */
        this.signupComponent = new signup_1.Signup(signupCtrl, this.ctrl.inviteToken);
        this.acceptInviteComponent = new InviteAcceptComponent(this.ctrl);
    }
    onCreate() {
        this.ctrl.validateInviteToken();
    }
    get component() {
        if (services_1.Services.SSO.isAuthenticated) {
            if (this.ctrl.validEmail) {
                return this.acceptInviteComponent;
            }
            else {
                return this.invalidAccountComponent;
            }
        }
        else if (this.ctrl.inviteMethod === accept_invite_ctrl_1.InviteMethod.LoggedIn) {
            return this.loggedInComponent;
        }
        else if (this.ctrl.inviteMethod === accept_invite_ctrl_1.InviteMethod.Login) {
            return this.loginComponent;
        }
        else if (this.ctrl.inviteMethod === accept_invite_ctrl_1.InviteMethod.Signup) {
            return this.signupComponent;
        }
        else if (this.ctrl.inviteMethod === accept_invite_ctrl_1.InviteMethod.Success) {
            return this.acceptInviteComponent;
        }
        else if (this.ctrl.inviteMethod === accept_invite_ctrl_1.InviteMethod.SuccessSSO) {
            return this.successSSOComponent;
        }
        else if (this.ctrl.inviteMethod === accept_invite_ctrl_1.InviteMethod.FailedSSO) {
            return this.failedSSOComponent;
        }
        return this.chooseComponent;
    }
    get nodes() {
        return (0, mithril_1.m)('form', { className: CSS.container }, [
            (0, mithril_1.m)('h3', (0, index_1.Translate)(index_1.T.INVITE_ACCEPT_TITLE)),
            !this.ctrl.awaitingCheck ? this.component.view() : spinner_1.Spinner.view()
        ]);
    }
    acceptNewSSOUser(success) {
        if (success) {
            this.ctrl.inviteNewSSOUser();
        }
        else {
            this.ctrl.failedNewSSOUser();
        }
    }
    checkValidEmail() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.ctrl.awaitingCheck = true;
            this.ctrl.setValidEmail(yield services_1.Services.Department.Invite.checkEmail(this.ctrl.inviteToken, services_1.Services.SSO.user.email));
            this.ctrl.awaitingCheck = false;
        });
    }
}
exports.AcceptInviteComponent = AcceptInviteComponent;
class LoggedInComponent extends mithril_component_1.IMithrilStateComponent {
    constructor(ctrl) {
        super();
        this.ctrl = ctrl;
    }
    get nodes() {
        return [
            (0, mithril_1.m)('p', { className: CSS.textSeparator }, this.ctrl.user.username),
            submit_button_1.SubmitButton.view({
                title: index_1.T.INVITE_ACCEPT_TITLE,
                submit: () => this.ctrl.inviteLoggedInUser(),
                submitting: this.ctrl.loading,
                className: auth_component_style_1.CSS.button,
                noAccent: true
            }),
            (0, mithril_1.m)('p', { className: CSS.textSeparator }, (0, index_1.Translate)(index_1.T.INVITE_TOKEN_OR)),
            submit_button_1.SubmitButton.view({
                title: index_1.T.CANCEL,
                submit: () => this.ctrl.cancel(),
                submitting: this.ctrl.loading,
                className: auth_component_style_1.CSS.button,
                noAccent: true
            })
        ];
    }
}
class InviteChooseMethodComponent extends mithril_component_1.IMithrilStateComponent {
    constructor(ctrl) {
        super();
        this.ctrl = ctrl;
    }
    get nodes() {
        if (this.ctrl.loading) {
            return spinner_1.Spinner.view();
        }
        if (!this.ctrl.validatedToken) {
            return [
                (0, mithril_1.m)('p', (0, index_1.Translate)(index_1.T.INVITE_TOKEN_INVALID)),
                this.viewExitButton()
            ];
        }
        return [
            (0, mithril_1.m)('p', { className: CSS.textSeparator }, (0, index_1.Translate)(index_1.T.INVITE_LOGIN_HELP)),
            (0, mithril_1.m)('button', {
                className: `mdl-button mdl-button--raised ${auth_component_style_1.CSS.button}`,
                onclick: () => {
                    services_1.Services.SSO.login({
                        redirect_uri: window.location.origin + services_1.Services.Route.getRouteURL(page_1.IkePageName.acceptInvite, { inviteToken: this.ctrl.inviteToken })
                    });
                }
            }, (0, index_1.Translate)(index_1.T.LOGIN_WITH_AUTH0)),
            (0, mithril_1.m)('p', { className: CSS.textSeparator }, (0, index_1.Translate)(index_1.T.INVITE_SIGNUP_HELP)),
            (0, mithril_1.m)('button', {
                className: `mdl-button mdl-button--raised ${auth_component_style_1.CSS.button}`,
                onclick: () => this.ctrl.setInviteMethod(accept_invite_ctrl_1.InviteMethod.Signup)
            }, (0, index_1.Translate)(index_1.T.SIGNUP))
        ];
    }
    viewExitButton() {
        return (0, mithril_1.m)('a', {
            className: `mdl-button mdl-button--raised ${auth_component_style_1.CSS.button}`,
            href: services_1.Services.Route.getRouteURL(page_1.IkePageName.root)
        }, (0, index_1.Translate)(index_1.T.CANCEL));
    }
}
class InviteAcceptComponent extends mithril_component_1.IMithrilComponent {
    constructor(ctrl) {
        super();
        this.ctrl = ctrl;
    }
    get nodes() {
        const successFunc = () => this.ctrl.completeSSOInvite();
        const pageText = (0, index_1.Translate)(index_1.T.INVITE_VALID_PROMPT);
        const buttonText = index_1.T.ACCEPT;
        return [
            (0, mithril_1.m)('p', { className: CSS.textSeparator }, pageText),
            submit_button_1.SubmitButton.view({
                title: buttonText,
                submit: successFunc,
                submitting: this.ctrl.loading,
                className: auth_component_style_1.CSS.button,
                noAccent: true
            })
        ];
    }
}
class InviteSuccessSSOComponent extends mithril_component_1.IMithrilComponent {
    constructor(ctrl) {
        super();
        this.ctrl = ctrl;
    }
    get nodes() {
        return [
            (0, mithril_1.m)('p', { className: CSS.textSeparator }, (0, index_1.Translate)(index_1.T.INVITE_SSO_CREATION_SUCCESS)),
            submit_button_1.SubmitButton.view({
                title: index_1.T.LOGIN,
                submit: () => services_1.Services.SSO.login({ redirect_uri: window.location.origin }),
                className: auth_component_style_1.CSS.button,
                noAccent: true
            })
        ];
    }
}
class InviteFailedSSOComponent extends mithril_component_1.IMithrilComponent {
    constructor(ctrl) {
        super();
        this.ctrl = ctrl;
    }
    get nodes() {
        return [
            (0, mithril_1.m)('p', { className: CSS.textSeparator }, (0, index_1.Translate)(index_1.T.INVITE_SSO_FAILED)),
            submit_button_1.SubmitButton.view({
                title: index_1.T.TRY_AGAIN,
                submit: () => services_1.Services.Route.go(page_1.IkePageName.acceptInvite, { inviteToken: this.ctrl.inviteToken }),
                className: auth_component_style_1.CSS.button,
                noAccent: true
            })
        ];
    }
}
class InviteInvalidAccountComponent extends mithril_component_1.IMithrilComponent {
    constructor(ctrl) {
        super();
        this.ctrl = ctrl;
    }
    get nodes() {
        return [
            (0, mithril_1.m)('p', { className: CSS.textSeparator }, (0, index_1.Translate)(index_1.T.INVITE_INVALID_ACCOUNT)),
            submit_button_1.SubmitButton.view({
                title: index_1.T.LOGOUT,
                submit: () => services_1.Services.SSO.logout(),
                className: auth_component_style_1.CSS.button,
                noAccent: true
            })
        ];
    }
}
//# sourceMappingURL=accept.invite.js.map